<template>
  <div class="container">
    <Main :title="singlepageTitle" :content="singlepageContent" />
  </div>
</template>

<script>
import Main from 'components/singlepage/Main.vue';

export default {
  components: {
    Main,
  },
  async fetch({ store, error }) {
    const { locale } = store.state;
    if (locale !== 'uk') {
      const params = {
        statusCode: 404,
      };
      error(params);
    }
  },
  data() {
    return {
      singlepageTitle: this.$t('cookiesPolicy.title'),
      singlepageContent: this.$t('cookiesPolicy.content'),
    }
  },
}
</script>
